import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import Logo from '../components/Logo';

export default function Login() {
  const { login }                   = useAuth();
  const [email, setEmail]           = useState('');
  const [password, setPassword]     = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe]     = useState(true);
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [sessionExpired]            = useState(() => {
    const flag = sessionStorage.getItem('session_expired');
    if (flag) sessionStorage.removeItem('session_expired');
    return !!flag;
  });

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/api/v1/auth/login', { email, password, rememberMe });
      login(res.data.token, res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
      setLoading(false);
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.brand}><Logo size={26} /></div>
        <div style={s.subtitle}>The operating system for injection moulding</div>

        <form onSubmit={handleLogin}>
          <div style={s.field}>
            <label style={s.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={s.input}
              placeholder="your@email.com"
              autoComplete="email"
              required
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ ...s.input, paddingRight: '44px' }}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(p => !p)}
                style={s.eyeBtn}
              >
                <i className={`fa-solid fa-eye${showPassword ? '-slash' : ''}`} style={{ fontSize: '14px', color: '#6b7280' }} />
              </button>
            </div>
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '20px' }}>
            <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} style={{ accentColor: '#14b8a6', width: '14px', height: '14px' }} />
            <span style={{ fontSize: '13px', color: '#9ca3af' }}>Keep me signed in for 30 days</span>
          </label>

          {sessionExpired && <div style={s.warning}>Your session expired — please sign in again.</div>}
          {error && <div style={s.error}>{error}</div>}

          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.6 : 1 }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div style={s.footer}>
          MouldOS · {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}

const s = {
  page:     { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f1117', fontFamily: 'system-ui, sans-serif', padding: '0 16px' },
  card:     { background: '#1e2329', border: '1px solid #2a3040', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '380px', boxSizing: 'border-box' },
  brand:    { marginBottom: '8px' },
  subtitle: { fontSize: '12px', color: '#6b7280', marginBottom: '32px' },
  field:    { marginBottom: '16px' },
  label:    { display: 'block', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#6b7280', marginBottom: '6px' },
  input:    { width: '100%', background: '#0f1117', border: '1px solid #2a3040', borderRadius: '8px', color: '#f0f2f5', padding: '10px 12px', fontSize: '14px', boxSizing: 'border-box' },
  eyeBtn:   { position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', padding: '4px' },
  warning:  { background: '#78350f', color: '#fcd34d', border: '1px solid #92400e', borderRadius: '8px', padding: '10px 12px', fontSize: '13px', marginBottom: '16px' },
  error:    { background: '#7f1d1d', color: '#fca5a5', border: '1px solid #991b1b', borderRadius: '8px', padding: '10px 12px', fontSize: '13px', marginBottom: '16px' },
  btn:      { width: '100%', background: '#14b8a6', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' },
  footer:   { marginTop: '24px', textAlign: 'center', fontSize: '11px', color: '#4b5563' },
};